import { graphql } from 'gql';

export const bimExportWorkOrderChangeAnalyticsAsExcelGql = graphql(`
    query bimExportWorkOrderChangeAnalyticsAsExcel($workOrderChangeId: Long!, $workOrderVersionId: Long!) {
        bimExportWorkOrderChangeAnalyticsAsExcel(
            workOrderChangeId: $workOrderChangeId
            workOrderVersionId: $workOrderVersionId
        ) {
            data {
                name
                count
                size
                dataUrl
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderChangePreviousVersionsGql = graphql(`
    query bimWorkOrderChangePreviousVersions(
        $workOrderChangeId: Long!
        $order: [BimWorkOrderVersionListItemSortInput!]
    ) {
        bimWorkOrderChangePreviousVersionsAsync(workOrderChangeId: $workOrderChangeId, order: $order) {
            items {
                workOrderVersionItem {
                    id
                    internalNumber
                    signingDate
                }
                workOrderChangeItem {
                    id
                    internalNumber
                    signingDate
                }
            }
        }
    }
`);

export const uerExportWorkOrderChangeAnalyticsAsExcelGql = graphql(`
    query uerExportWorkOrderChangeAnalytics($workOrderChangeId: Long!, $workOrderVersionId: Long!) {
        uerExportWorkOrderChangeAnalytics(
            workOrderChangeId: $workOrderChangeId
            workOrderVersionId: $workOrderVersionId
        ) {
            data {
                name
                count
                size
                dataUrl
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerWorkOrderChangePreviousVersionsGql = graphql(`
    query uerWorkOrderChangePreviousVersions($workOrderChangeId: Long!, $order: [WorkOrderVersionListItemSortInput!]) {
        uerWorkOrderChangePreviousVersions(workOrderChangeId: $workOrderChangeId, order: $order) {
            workOrderVersionItem {
                id
                internalNumber
                signingDate
                status
            }
            workOrderChangeItem {
                id
                internalNumber
                signingDate
            }
        }
    }
`);
